/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  server-constants.ts
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali (H175591)
 *
 * @Date         : Dec 12, 2019
 *
 * @Version      : Version 1.0
 *
 * By            	: Madhu Gali (H175591)
 * On            	: Dec 12, 2019
 * Description   	: ASDS-584
 *
 * By            : Madhu Gali - H175591
 * On            : Jan 10, 2019
 * Description   : ASDS-2152
 *
 * By            : Madhu Gali - H175591
 * On            : Feb 05, 2020
 * Description   : ASDS-2271
 *
 * By            : Madhu Gali - H175591
 * On            : Feb 19, 2020
 * Description   : ASDS-2355
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Mar 19, 2020
 * Description   : ASDS-2443 - Added My Licenses url for Navigation from checkout
 *
 * By            : H224423
 * On            : Mar 23, 2020
 * Description   : ASDS-1052 Forge Header Logout functionality changes
 *
 * By            : H224423
 * On            : Mar 24, 2020
 * Description   : Updated forge prod url
 *
 * By            : E807958
 * On            : Mar 30, 2020
 * Description   : ASDS-1763
 *
 * By            : H422335
 * On            : Nov 10, 2020
 * Description   : ASDS-4048 Changes to react backend URL from Octopus variables
 *
 * By            : H422335
 * On            : Dec 02, 2020
 * Description   : Updates to production URLs
 *
 * By            : H422335
 * On            : Dec 16, 2020
 * Description   : Deprecated openshift 3 URLs, changing UI access URL to kong
 ******************************************************************************/
export enum StandardEnvironments {
  local = "LOCAL",
  forgeDev = "FORGE_DEV",
  forgeQA = "FORGE_QA",
  forgeProd = "FORGE_PROD",
  ut = "UT"
}

export enum StandardEnvironmentsURLs {
  localURL = "https://lsdc.honeywellaerospace.com:3000/sdc",
  forgeDevURL = "https://asds-checkout-dev.qaerospace1.honeywellaerospace.com",
  forgeQAURL = "https://asds-checkout.qaerospace1.honeywellaerospace.com",
  forgeProdURL = "https://asds-checkout.aerospace1.honeywellaerospace.com"
}

export enum AppConsts {
  clientId = "asds-checkout-f2c3de",
  authorization_code = "authorization_code"
}

export const registeredForgeDomains = [
  {
    url: `${StandardEnvironmentsURLs.localURL}`,
    env: `${StandardEnvironments.local}`
  },
  {
    url: `${StandardEnvironmentsURLs.forgeDevURL}`,
    env: `${StandardEnvironments.forgeDev}`
  },
  {
    url: `${StandardEnvironmentsURLs.forgeQAURL}`,
    env: `${StandardEnvironments.forgeQA}`
  },
  {
    url: `${StandardEnvironmentsURLs.forgeProdURL}`,
    env: `${StandardEnvironments.forgeProd}`
  }
];

export const registeredDomains = registeredForgeDomains;

const FORGE_NON_PROD_BASE_URL = "https://identity-qa.honeywellaerospace.com";
const FORGE_PROD_BASE_URL = "https://identity.honeywellaerospace.com";

const REDIRECT_URL = "/oauth2/auth?response_type=code" +
"&client_id=asds-checkout-f2c3de&state=123456789&scope=openid+email+groups+customersub+offline&customer_hint=&redirect_uri=";

const forgeEnvConstants = {
  [StandardEnvironments.local]: {
    APP_ENV: StandardEnvironments.local,
    FORGE_SSO_URL: `${FORGE_NON_PROD_BASE_URL}${REDIRECT_URL}${StandardEnvironmentsURLs.localURL}`,
    // BACKEND_BASE_URL:"https://asds-exp-api.qaerospace1.honeywellaerospace.com",                   // "https://asds-exp-api-dev.qaerospace1.honeywellaerospace.com",  // New Kong URL
    BACKEND_BASE_URL:   "https://asds-exp-api-afgkjtgm-qa-dskmulis.apps.dev.aks.honaero.com", //"https://asds-exp-api-afgkjtgm-vgmtgngn-dlucfbyp.apps.dev.forgeapp.honeywellaerospace.com", // Non-kong (Openshift4) URL
    APP_USERINFO_URL: `${FORGE_NON_PROD_BASE_URL}${"/userinfo"}`,
    FORGE_ACCESS_TOKEN_URL: `${FORGE_NON_PROD_BASE_URL}${"/oauth2/token"}`,
    ADS_DASHBOARD_URL:
      "https://qads.honeywellaerospace.com/ads/broadcast/message",
    MY_LICENSES_URL:
      "https://qads.honeywellaerospace.com/ads/licenses/download",
      NEED_HELP_URL: "https://qads.honeywellaerospace.com/support/form",
      USER_GUIDE_URL : 'https://aerospace6.honeywellaerospace.com/en/~/media/aero-fss-content/ads/PurchaseSoftware/User_Guide/index.htm',
       FORGE_ADS_REDIRECT_URL: `${StandardEnvironmentsURLs.localURL}`,
    APP_DEBUG_ENABLE: true,
    JOULE_REDIRECT_URL: "https://stage.honeywellaerospace.com/en",
    ASDS_ROLE_ACCESS_URL:
      "https://stage.honeywellaerospace.com/en/redirects/sso/aerospace-software-and-data-services",
    AEROSPACE_LOGOUT_URL: 'https://qaerospace2.honeywell.com/onlineordering/Logoff?URL=logoutLink',
    MANAGE_ACCOUNT_INFO:'https://stage.honeywellaerospace.com/en/account',
  },
  [StandardEnvironments.forgeDev]: {
    APP_ENV: StandardEnvironments.forgeDev,
    FORGE_SSO_URL: `${FORGE_NON_PROD_BASE_URL}${REDIRECT_URL}${StandardEnvironmentsURLs.forgeDevURL}`,
    BACKEND_BASE_URL: "https://asds-exp-api-dev.qaerospace1.honeywellaerospace.com",  // New Kong URL
    // BACKEND_BASE_URL: "https://asds-exp-api-afgkjtgm-vgmtgngn-dlucfbyp.apps.dev.forgeapp.honeywellaerospace.com",  // New Non-Kong(Openshift4) URL
    APP_USERINFO_URL: `${FORGE_NON_PROD_BASE_URL}${"/userinfo"}`,
    FORGE_ACCESS_TOKEN_URL:`${FORGE_NON_PROD_BASE_URL}${"/oauth2/token"}`,
    FORGE_LOGOUT_URL:`${FORGE_NON_PROD_BASE_URL}${"/oauth2/sessions/logout"}`,
    ADS_DASHBOARD_URL: "https://dasds.honeywell.com:8980/ads/broadcast/message",
    MY_LICENSES_URL: "https://dasds.honeywell.com:8980/ads/licenses/download",
    NEED_HELP_URL: "https://dasds.honeywell.com:8980/support/form",
    USER_GUIDE_URL : 'https://aerospace6.honeywellaerospace.com/en/~/media/aero-fss-content/ads/PurchaseSoftware/User_Guide/index.htm',
    FORGE_ADS_REDIRECT_URL: StandardEnvironmentsURLs.forgeDevURL,
    APP_DEBUG_ENABLE: true,
    JOULE_REDIRECT_URL: "https://stage.honeywellaerospace.com/en",
    ASDS_ROLE_ACCESS_URL:
      "https://stage.honeywellaerospace.com/en/redirects/sso/aerospace-software-and-data-services",
    AEROSPACE_LOGOUT_URL: 'https://qaerospace2.honeywell.com/onlineordering/Logoff?URL=logoutLink',
    MANAGE_ACCOUNT_INFO:'https://stage.honeywellaerospace.com/en/account',
  },
  [StandardEnvironments.forgeQA]: {
    APP_ENV: StandardEnvironments.forgeQA,
    FORGE_SSO_URL: `${FORGE_NON_PROD_BASE_URL}${REDIRECT_URL}${StandardEnvironmentsURLs.forgeQAURL}`,
    BACKEND_BASE_URL: "https://asds-exp-api.qaerospace1.honeywellaerospace.com",   // New KongURL
    // BACKEND_BASE_URL: "https://asds-exp-api-afgkjtgm-fdofthoy-dlucfbyp.apps.dev.forgeapp.honeywellaerospace.com",  // New Non-Kong(Openshift4) URL
    APP_USERINFO_URL: `${FORGE_NON_PROD_BASE_URL}${"/userinfo"}`,
    FORGE_ACCESS_TOKEN_URL:`${FORGE_NON_PROD_BASE_URL}${"/oauth2/token"}`,
    FORGE_LOGOUT_URL:`${FORGE_NON_PROD_BASE_URL}${"/oauth2/sessions/logout"}`,
    ADS_DASHBOARD_URL: "https://qads.honeywellaerospace.com/ads/broadcast/message",
    MY_LICENSES_URL: "https://qads.honeywellaerospace.com/ads/licenses/download",
    NEED_HELP_URL: "https://qads.honeywellaerospace.com/support/form",
    USER_GUIDE_URL : 'https://aerospace6.honeywellaerospace.com/en/~/media/aero-fss-content/ads/PurchaseSoftware/User_Guide/index.htm',
    FORGE_ADS_REDIRECT_URL: StandardEnvironmentsURLs.forgeQAURL,
    APP_DEBUG_ENABLE: true,
    JOULE_REDIRECT_URL: "https://stage.honeywellaerospace.com/en",
    ASDS_ROLE_ACCESS_URL:
      "https://stage.honeywellaerospace.com/en/redirects/sso/aerospace-software-and-data-services",
    AEROSPACE_LOGOUT_URL: 'https://qaerospace2.honeywell.com/onlineordering/Logoff?URL=logoutLink',
    MANAGE_ACCOUNT_INFO:'https://stage.honeywellaerospace.com/en/account',
  },
  [StandardEnvironments.forgeProd]: {
    APP_ENV: StandardEnvironments.forgeProd,
    FORGE_SSO_URL: `${FORGE_PROD_BASE_URL}${REDIRECT_URL}${StandardEnvironmentsURLs.forgeProdURL}`,
    BACKEND_BASE_URL: "https://asds-exp-api.aerospace1.honeywellaerospace.com",
    APP_USERINFO_URL: `${FORGE_PROD_BASE_URL}${"/userinfo"}`,
    FORGE_ACCESS_TOKEN_URL:`${FORGE_PROD_BASE_URL}${"/oauth2/token"}`,
    FORGE_LOGOUT_URL:`${FORGE_PROD_BASE_URL}${"/oauth2/sessions/logout"}`,
    ADS_DASHBOARD_URL: "https://ads.honeywellaerospace.com/ads/broadcast/message",
    MY_LICENSES_URL: "https://ads.honeywellaerospace.com/ads/licenses/download",
    NEED_HELP_URL: "https://ads.honeywellaerospace.com/support/form",
    USER_GUIDE_URL : 'https://aerospace6.honeywellaerospace.com/en/~/media/aero-fss-content/ads/PurchaseSoftware/User_Guide/index.htm',
    FORGE_ADS_REDIRECT_URL: StandardEnvironmentsURLs.forgeProdURL,
    APP_DEBUG_ENABLE: true,
    JOULE_REDIRECT_URL: "https://www.honeywellaerospace.com/en",
    ASDS_ROLE_ACCESS_URL:
      "https://www.honeywellaerospace.com/en/redirects/sso/aerospace-software-and-data-services",
    AEROSPACE_LOGOUT_URL: 'https://aerospace2.honeywell.com/onlineordering/Logoff?URL=logoutLink',
    MANAGE_ACCOUNT_INFO:'https://www.honeywellaerospace.com/en/account',
  },
  [StandardEnvironments.ut]: {
    APP_ENV: StandardEnvironments.ut,
    FORGE_SSO_URL: "sample",
    BACKEND_BASE_URL: "https://sample",
    APP_USERINFO_URL: "",
    FORGE_ACCESS_TOKEN_URL: "sample",
    ADS_DASHBOARD_URL: "sample",
    MY_LICENSES_URL: "sample",
    FORGE_ADS_REDIRECT_URL: "sample",
    APP_DEBUG_ENABLE: false,
    JOULE_REDIRECT_URL: "https://stage.honeywellaerospace.com/en",
    AEROSPACE_LOGOUT_URL: 'https://qaerospace2.honeywell.com/onlineordering/Logoff?URL=logoutLink',
    MANAGE_ACCOUNT_INFO:'https://stage.honeywellaerospace.com/en/account',
  }
};

export const envConstants = { ...forgeEnvConstants };

